import * as React from 'react';
import { useSelector } from 'react-redux';
import { trackBlockClick, trackBlockShow } from './tracking';
import { PromoOffersList } from '../../components/PromoOffersList';
import { listingUrlSelector } from '../../selectors/promoOffersSelection';
import { selectPromoOffers, promoOffersIdsSelector } from '../../selectors/promoOffersSelection/promoOffersSelector';

export const PromoOffersSelection = () => {
  const url = useSelector(listingUrlSelector);
  const offers = useSelector(selectPromoOffers);
  const offersIds = useSelector(promoOffersIdsSelector);

  const onListShow = React.useCallback(() => {
    trackBlockShow(offersIds);
  }, [offersIds]);

  const onListingClick = React.useCallback(() => {
    trackBlockClick({ offersIds, clickType: 'to_listing' });
  }, [offersIds]);

  const onListingModalClick = React.useCallback(() => {
    trackBlockClick({ offersIds, clickType: 'to_listing_modal' });
  }, [offersIds]);

  if (!url || !offers.length) {
    return null;
  }

  return (
    <PromoOffersList
      title="Могут подойти"
      subtitle="Выгодные предложения по вашим поискам"
      offers={offers}
      url={url}
      onListShow={onListShow}
      onListingClick={onListingClick}
      onListingModalClick={onListingModalClick}
    />
  );
};
